import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse
} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {tap} from "rxjs/operators";
import {Injector} from "@angular/core";
import {Router} from "@angular/router";

export class MaintenanceInterceptor implements HttpInterceptor {

  private get router(): Router {
    return this.injector.get(Router);
  }

  constructor(private injector: Injector) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
        }
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 503) {
            this.router.navigate(['maintenance']);
          }
        }
      })
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/core/visbos-core/maintenance/maintenance.interceptor.ts